import { WRENCH_MODE_EVENTS_CRUD_ACTION_CONSTANTS as CRUD_ACTION_CONSTANTS } from '../actions/wrench_mode_events_actions';
import { standardInitialStateGenerator, standardReducerGenerator } from './standard_reducer_utils';

const initialState: any = standardInitialStateGenerator(['wrenchModeEventsForSchedule']);
export default standardReducerGenerator(CRUD_ACTION_CONSTANTS, initialState);
